export default __webpack_public_path__ + "f3d3e9f075f2be4efb5e316e3e1dd37d.webp";